/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Case_MaterialInputs */

const en_field_case_material = /** @type {(inputs: Field_Case_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case Material`)
};

const es_field_case_material = /** @type {(inputs: Field_Case_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material de la caja`)
};

const fr_field_case_material = /** @type {(inputs: Field_Case_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matière du boîtier`)
};

const de_field_case_material = /** @type {(inputs: Field_Case_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehäusematerial`)
};

const ja_field_case_material = /** @type {(inputs: Field_Case_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ケース素材`)
};

const zh_field_case_material = /** @type {(inputs: Field_Case_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表壳材质`)
};

const ar_field_case_material = /** @type {(inputs: Field_Case_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مادة الهيكل`)
};

const id_field_case_material = /** @type {(inputs: Field_Case_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material Wadah`)
};

const it_field_case_material = /** @type {(inputs: Field_Case_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Materiale Cassa`)
};

const ru_field_case_material = /** @type {(inputs: Field_Case_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Материал корпуса`)
};

const pt_field_case_material = /** @type {(inputs: Field_Case_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material da Caixa`)
};

const ko_field_case_material = /** @type {(inputs: Field_Case_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`케이스 소재`)
};

/**
* | output |
* | --- |
* | "Case Material" |
*
* @param {Field_Case_MaterialInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_case_material = /** @type {((inputs?: Field_Case_MaterialInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Case_MaterialInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_case_material(inputs)
	if (locale === "es") return es_field_case_material(inputs)
	if (locale === "fr") return fr_field_case_material(inputs)
	if (locale === "de") return de_field_case_material(inputs)
	if (locale === "ja") return ja_field_case_material(inputs)
	if (locale === "zh") return zh_field_case_material(inputs)
	if (locale === "ar") return ar_field_case_material(inputs)
	if (locale === "id") return id_field_case_material(inputs)
	if (locale === "it") return it_field_case_material(inputs)
	if (locale === "ru") return ru_field_case_material(inputs)
	if (locale === "pt") return pt_field_case_material(inputs)
	return ko_field_case_material(inputs)
});